import axios from 'axios';

const request = axios.create({
    // baseURL:'http://219.248.246.69'
    baseURL:process.env.VUE_APP_BUILD_URL,
    withCredentials:true
});

export default request;